import React from 'react';
import { BRAND } from '../data/mock';
import { Mail, MapPin, Clock, Phone } from 'lucide-react';

export default function TopBar() {
  return (
    <div className="hidden md:block w-full bg-[#314F2B] border-b border-[#6A8F3E]/15 relative z-[55]">
      <div className="mx-auto px-6 md:px-12 py-2.5 flex items-center justify-between" style={{ maxWidth: '1700px' }}>
        <div className="flex items-center gap-6 text-[10px] tracking-[0.18em] uppercase text-[#E7E9E4] font-medium">
          <span className="flex items-center gap-2">
            <Clock size={12} className="text-[#6A8F3E]" strokeWidth={1.6} />
            <span>Mon — Fri</span>
            <span className="text-[#E7E9E4]/35">·</span>
            <span>07:30 — 17:30</span>
          </span>
          <span className="hidden lg:flex items-center gap-2">
            <MapPin size={12} className="text-[#6A8F3E]" strokeWidth={1.6} />
            <span>{BRAND.area}</span>
          </span>
          <a href={`mailto:${BRAND.email}`} data-cursor="hover" className="hidden lg:flex items-center gap-2 hover:text-[#6A8F3E] transition-colors link-underline">
            <Mail size={12} className="text-[#6A8F3E]" strokeWidth={1.6} />
            <span>{BRAND.email}</span>
          </a>
        </div>

        {/* Phone CTA — anchored top-right.  Visible on tablet+ since the
            navbar's "GET IN TOUCH" already covers the larger primary CTA. */}
        <a
          href={`tel:${BRAND.phoneTel}`}
          data-cursor="hover"
          data-testid="topbar-phone"
          className="group flex items-center gap-2.5 text-[#E7E9E4] hover:text-[#A3C66F] transition-colors"
        >
          <span className="w-6 h-6 rounded-full bg-[#6A8F3E]/20 group-hover:bg-[#6A8F3E] border border-[#6A8F3E]/40 group-hover:border-[#6A8F3E] flex items-center justify-center transition-all">
            <Phone size={11} className="text-[#A3C66F] group-hover:text-[#162A1E] transition-colors" strokeWidth={2.2} />
          </span>
          <span className="text-[10px] tracking-[0.22em] uppercase font-bold">
            Call us
          </span>
          <span className="text-[12px] tracking-[0.06em] font-bold text-[#E7E9E4] group-hover:text-[#A3C66F] transition-colors">
            {BRAND.phone}
          </span>
        </a>
      </div>
    </div>
  );
}
